export function isNullOrEmpty<T>(value?: T | null): boolean {
  return value === null || value === undefined || value === '';
}
